var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M35 35H14.385a.424.424 0 01-.148-.053 1.465 1.465 0 01-.425-2.759l18.376-18.376A1.487 1.487 0 0135 14.5c0 .024-.013.044-.014.067-.001.023.014.04.014.062V35zm-5.008-12L23 29.992h6.992V23z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
